import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';

import { ConfirmModalComponent } from '../modals/confirm-modal/confirm-modal.component';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private modalService: NgbModal;

  constructor() {
    this.modalService = inject(NgbModal);
  }

  public showConfirm(title = '', text = ''): Observable<boolean> {
    const resultSubject = new Subject<boolean>();

    const modal = this.modalService.open(ConfirmModalComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'dark-modal ltr',
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
    });

    (modal.componentInstance as ConfirmModalComponent).title = title;
    (modal.componentInstance as ConfirmModalComponent).text = text;

    // eslint-disable-next-line promise/catch-or-return
    modal.result.then(
      (result: boolean) => {
        // eslint-disable-next-line promise/always-return
        if (result) {
          resultSubject.next(true);
        } else {
          resultSubject.next(false);
        }

        resultSubject.complete();
      },
      () => {
        resultSubject.next(false);
        resultSubject.complete();
      }
    );
    return resultSubject;
  }
}
